import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Lesson } from '../models/lesson';

@Injectable({
  providedIn: 'root'
})
export class LessonService {

  constructor(
    private _http: HttpClient
  ) { }

  public getLessons(courseId:number){
    return this._http.get(environment.apiEndpoint + '/api/admin/lessons/' + courseId).pipe(
      map(res => {
        return res;
      })
    );
  }

  public updateLesson(lesson:Lesson){
    return this._http.put(environment.apiEndpoint + '/api/admin/lesson', {lesson:lesson}).pipe(
      map(
        res => {
          return res;
        }
      )
    );
  }

  public updateLessons(lessons:Lesson[]): Observable<any>{
    return this._http.put(environment.apiEndpoint+'/api/admin/lessons', {lessons:lessons}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public addLesson(courseId:number, courseOrder:number){
    return this._http.post(environment.apiEndpoint + '/api/admin/lesson', {courseId:courseId,courseOrder:courseOrder}).pipe(
      map(
        res => {
          return res;
        }
      )
    );
  }

  public deleteLesson(lessonId:number){
    return this._http.delete(environment.apiEndpoint + '/api/admin/lesson/' + lessonId).pipe(
      map(
        res => {
          return res;
        }
      )
    );
  }
}
